import React, { Component } from 'react'

import View from 'react-flexbox'
import { Typography } from '@material-ui/core';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';


class ConstainerTitulo extends Component {
    
    render() {
        const { titulo, actionclose, classes, style } = this.props;

        return (
            <View column style={{ height: 'inherit', overflow: 'hidden', ...style }}>


                <View className={classes.header} style={{ flexGrow: 0, padding: 5, paddingLeft: 16, paddingRight: 16, alignItems: 'center' }} >
                    <Typography variant="h6" color="inherit" noWrap style={{ flexGrow: 1, }}>
                        {titulo}
                    </Typography>
                    {this.props.actionclose &&
                        <Button color="inherit" className="pesquisa-fechar-btn" onClick={actionclose}>
                            <Close onClick={actionclose} />
                        </Button>
                    }
                    {this.props.acoes && (
                        <View style={{ justifyContent: "flex-end" }}>
                            {this.props.acoes.map((a, index) => {
                                return <Button key={index} color="inherit" onClick={a.onClick}>
                                    {a.icon}
                                    {a.label}
                                </Button>
                            })}

                        </View>
                    )}
                    {this.props.comonenteAcoes ?
                        this.props.comonenteAcoes : ""
                    }
                </View>
                <View column style={{ flexGrow: 1 }}>
                    {this.props.children}
                </View>

            </View >
        )
    }
}

const styles = theme => {

    return {
        header: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            flexGrow: 0, padding: 5, paddingLeft: 16, paddingRight: 16, alignItems: 'center'
        }
    }
};

ConstainerTitulo = withStyles(styles)(ConstainerTitulo);

export default ConstainerTitulo;



// WEBPACK FOOTER //
// ./src/components/ConstainerTitulo.js